import { gsap } from 'gsap';

export default class GlassCredit {
	constructor(elm) {
		this.elm = elm;

		this.isAnimating = false;
		this.isOpen = false;

		this.glass = this.elm.querySelector('[data-glass-credits-glass]');
		this.button = this.elm.querySelector('[data-glass-credits-button]');
		this.text = this.elm.querySelector('[data-glass-credits-text]');

		this.init();
	}

	init() {
		this.elm.addEventListener('click', () => {
			if (this.isOpen) {
				this.close();
			} else {
				this.open();
			}
		});

		this.elm.addEventListener('mouseenter', () => {
			this.open();
		});

		this.elm.addEventListener('mouseleave', () => {
			this.close();
		});
	}

	open() {
		if (this.isAnimating || this.isOpen) {
			return;
		}
		this.isAnimating = true;
		this.elm.classList.add('c-glass-credits--open');

		return new Promise((resolve) => {
			const width = this.text.scrollWidth;
			const height = this.text.scrollHeight;

			const tl = gsap.timeline({
				onComplete: () => {
					this.isOpen = true;
					this.isAnimating = false;

					resolve();
				},
			});

			tl.to(this.glass, {
				height: height,
				width: width,
				borderRadius: 8,
				duration: 0.4,
				ease: 'sine.inOut',
			});

			tl.to(
				this.button,
				{
					opacity: 0,
					duration: 0.4,
					ease: 'none',
				},
				0,
			);

			tl.to(this.text, {
				opacity: 1,
				duration: 0.4,
				ease: 'none',
			});
		});
	}

	close() {
		if (this.isAnimating || !this.isOpen) {
			return;
		}

		this.elm.classList.remove('c-glass-credits--open');
		this.isAnimating = true;

		return new Promise((resolve) => {
			const width = this.button.scrollWidth;
			const height = this.button.scrollHeight;

			const tl = gsap.timeline({
				onComplete: () => {
					this.isOpen = false;
					this.isAnimating = false;

					resolve();
				},
			});

			tl.to(this.text, {
				opacity: 0,
				duration: 0.4,
				ease: 'none',
			});

			tl.to(this.glass, {
				height: height,
				width: width,
				borderRadius: 21,
				duration: 0.4,
				ease: 'sine.inOut',
			});

			tl.to(
				this.button,
				{
					opacity: 1,
					duration: 0.4,
					ease: 'none',
				},
				'<',
			);
		});
	}
}
